/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { OnboardingLayout } from 'assets/components';
import { OnboardingProvider } from '../../contexts/onboarding/context';
import Signup from './Signup';
import ConfirmEmail from './ConfirmEmail';
import { onboardingScreens } from './constants';
import AddPhoneNumber from './AddPhoneNumber';
import ConfirmPhoneNumber from './ConfirmPhoneNumber';
import AddPersonalInformation from './AddPersonalInformation';
import AddPhysicalAddress from './AddPhysicalAddress';
import AddMailingAddress from './AddMailingAddress';
import Login from './Login';
import TFASecurity from './TFASecurity';
import ChangePasswordRequest from './ChangePasswordRequest';
import ConfirmPasswordRequestEmail from './ConfirmPasswordRequestEmail';
import CreateNewPassword from './CreateNewPassword';
import AdditionalPersonalDetails from './AdditionalPersonalDetails';

const Onboarding = ({ screen }) => (
  <OnboardingProvider>
    <OnboardingLayout currentScreen={screen}>
      <Signup keyName={onboardingScreens.SIGNUP} />
      <ConfirmEmail keyName={onboardingScreens.CONFIRM_EMAIL} />
      <AddPhoneNumber keyName={onboardingScreens.ADD_PHONE_NUMBER} />
      <ConfirmPhoneNumber keyName={onboardingScreens.CONFIRM_PHONE_NUMBER} />
      <AddPersonalInformation keyName={onboardingScreens.ADD_PERSONAL_INFO} />
      <AdditionalPersonalDetails keyName={onboardingScreens.ADDITIONAL_PERSONAL_DETAILS} />
      <AddPhysicalAddress keyName={onboardingScreens.ADD_PHYSICAL_ADDRESS} />
      <AddMailingAddress keyName={onboardingScreens.ADD_MAILING_ADDRESS} />
      <Login keyName={onboardingScreens.LOGIN} />
      <TFASecurity keyName={onboardingScreens.TFA} />
      <ChangePasswordRequest keyName={onboardingScreens.RESET_PASSWORD_REQUEST} />
      <ConfirmPasswordRequestEmail keyName={onboardingScreens.CONFIRM_RESET_PASSWORD_EMAIL} />
      <CreateNewPassword keyName={onboardingScreens.CREATE_NEW_PASSWORD} />
    </OnboardingLayout>
  </OnboardingProvider>
);
export default Onboarding;

Onboarding.propTypes = {
  screen: PropTypes.string.isRequired,
};
